import { render, staticRenderFns } from "./SpcCarriersDashboard.vue?vue&type=template&id=11694c82&scoped=true"
import script from "./SpcCarriersDashboard.vue?vue&type=script&lang=js"
export * from "./SpcCarriersDashboard.vue?vue&type=script&lang=js"
import style0 from "./SpcCarriersDashboard.vue?vue&type=style&index=0&id=11694c82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11694c82",
  null
  
)

export default component.exports